<template>
  <Navbar></Navbar>
  <div class="content-wrapper">
    <div class="main-content">
      <EventsComponent />
    </div>
    <FooterItem />
  </div>
</template>

<script>
import Navbar from "@/components/Layout/Navbar.vue";
import FooterItem from "@/components/Layout/FooterItem.vue";
import EventsComponent from "@/components/Events/EventsComponent.vue";
import { useHead } from "@vueuse/head";
import { mapGetters } from "vuex";
import store from "@/store";
export default {
  components: {
    Navbar,
    EventsComponent,
    FooterItem,
  },
  computed: {
    ...mapGetters(["currentLanguage"]),
  },
  methods: {
    updateHeadMeta() {
      const title =
        this.currentLanguage === "ar"
          ? "الأحداث القادمة - Planning Force | اكتشف أحداثنا التعليمية القادمة"
          : "Upcoming Events - Planning Force | Discover Our Upcoming Learning Events";

      const description =
        this.currentLanguage === "ar"
          ? "استكشف الأحداث القادمة التي تنظمها Planning Force في مجالات التعليم الإلكتروني والتدريب، وابدأ رحلتك التعليمية اليوم."
          : "Explore the upcoming events organized by Planning Force in the fields of e-learning and training, and start your learning journey today.";

      const keywords =
        this.currentLanguage === "ar"
          ? "أحداث, فعاليات, تعليم إلكتروني, تدريب, Planning Force, تعلم, ورش عمل"
          : "events, upcoming events, e-learning, training, Planning Force, learning, workshops";

      useHead({
        title: title,
        meta: [
          { name: "description", content: description },
          { name: "keywords", content: keywords },
          { name: "robots", content: "index, follow" },
          {
            name: "author",
            content:
              this.currentLanguage === "ar"
                ? "Planning Force"
                : "Planning Force",
          },
          {
            name: "language",
            content: this.currentLanguage === "ar" ? "ar" : "en",
          },

          // Open Graph meta tags
          { property: "og:title", content: title },
          { property: "og:description", content: description },
          {
            property: "og:image",
            content: "https://example.com/upcoming-events.jpg",
          }, // Replace with your events page image URL
          { property: "og:url", content: "https://example.com/events" }, // Replace with your events page URL
          { property: "og:type", content: "website" },

          // Twitter Card meta tags
          { name: "twitter:card", content: "summary_large_image" },
          { name: "twitter:title", content: title },
          { name: "twitter:description", content: description },
          {
            name: "twitter:image",
            content: "https://example.com/upcoming-events.jpg",
          }, // Replace with your events page image URL
        ],
      });
    },
  },
  mounted() {
    this.updateHeadMeta();
  },
  watch: {
    currentLanguage: {
      handler(newLang, oldLang) {
        //  this.language = newLang;
        this.updateHeadMeta();
        store.dispatch("categoriesList");
      },
      immediate: true, // Run the handler immediately when the component is mounted
    },
  },
};
</script>
